import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';
import ProductCard from './ProductCard';
const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.06 } },
};
const ProductGrid = ({ products, onAddToCart }) => {
    return (
        <div className="max-w-7xl mx-auto px-4 py-10">
            <AnimatePresence mode="wait">
                {products.length === 0 ? (
                    <motion.div
                        key="empty"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="flex flex-col items-center justify-center py-24 text-center gap-4"
                    >
                        <div className="w-24 h-24 rounded-full bg-slate-100 dark:bg-store-gray-dark/40 border border-slate-200 dark:border-store-border flex items-center justify-center text-4xl shadow-sm">
                            <Icon icon="solar:box-minimalistic-bold-duotone" className="text-4xl text-slate-500 dark:text-store-gray" />
                        </div>
                        <p className="text-slate-900 dark:text-white font-semibold text-lg">Aucun produit trouvé</p>
                        <p className="text-slate-500 dark:text-store-gray text-sm">Essayez une autre catégorie ou un autre filtre.</p>
                    </motion.div>
                ) : (
                    <motion.div
                        key="grid"
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                        className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 auto-rows-[280px] gap-4 md:gap-5"
                        style={{ gridAutoFlow: 'dense' }}
                    >
                        {products.map((product, i) => {
                            // Bento: only width variations, uniform row height
                            const isWide = i % 5 === 0;

                            return (
                                <ProductCard
                                    key={product.id}
                                    product={product}
                                    index={i}
                                    onAddToCart={onAddToCart}
                                    className={isWide ? 'col-span-2' : 'col-span-1'}
                                    variant={isWide ? 'wide' : 'overlay'}
                                />
                            );
                        })}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};
export default ProductGrid;